module.exports = __webpack_public_path__ + "static/media/SOAK-BNB.bddc64a8.svg";